import {gql} from 'apollo-angular';
export const GET_GAME_STORY_QUIZ = gql`
  query getGameStoryQuiz($clientId: String!, $storyId: Int!) {
    getStoryGame(clientID: $clientId, storyID: $storyId){
      id,
      status {
        type,
        message
      }
    }
  }
`;
